import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/HomePage.head';
import { HomePage } from '@pages/HomePage';

export const Route = createFileRoute('/')({
  component: HomePage,
  head: () => head,
});
